import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../app/utils/baseQueryWithReauth';

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: baseQueryWithReauth(process.env.REACT_APP_USER_SERVICE_URL),
    endpoints: (builder) => ({
        getCurrentUser: builder.query({
            query: () => '/v1/me',
        }),
        getLang: builder.query({
            query: (current) => current ? `/v1/lang?current=${encodeURIComponent(current)}` : '/v1/lang',
        }),
        setLang: builder.mutation({
            query: (lang) => ({
                url: '/v1/lang',
                method: 'POST',
                body: { lang },
            })
        }),
    }),
});


export const {
    useGetCurrentUserQuery,
    useLazyGetCurrentUserQuery,
    useGetLangQuery,
    useLazyGetLangQuery,
    useSetLangMutation,
} = userApi;
